/**
 * Helper functions για το YardView
 */

/**
 * Επιστρέφει το κείμενο που θα εμφανιστεί για το truck
 */
export const getTruckDisplayText = (booking, showSupplier) => {
    if (showSupplier) {
        return booking?.SUPPLIER_SHORTNAMES || booking?.TRUCK_LICENSENO || booking?.BOOKINGID;
    } else {
        return booking?.TRUCK_LICENSENO || booking?.SUPPLIER_SHORTNAMES || booking?.BOOKINGID;
    }
};

/**
 * Υπολογίζει πόσες ράμπες χωράνε ανά γραμμή
 */
export const calculateRampsPerRow = (windowWidth) => {
    const concreteElement = document.querySelector('.concrete-under-the-ramps');
    if (!concreteElement) {
        const estimatedConcreteWidth = windowWidth * 0.7;
        const rampWidth = 29;
        const gapWidth = 4;
        const padding = 16;
        const availableWidth = estimatedConcreteWidth - padding;
        return Math.max(4, Math.floor(availableWidth / (rampWidth + gapWidth)));
    }

    const concreteWidth = concreteElement.offsetWidth;
    const rampWidth = 29;
    const gapWidth = 4;
    const paddingLeft = 8;
    const paddingRight = 8;

    const availableWidth = concreteWidth - paddingLeft - paddingRight;
    const rampsPerRow = Math.floor(availableWidth / (rampWidth + gapWidth));
    return Math.max(1, rampsPerRow);
};
